export default __webpack_public_path__ + "_/videos/lootbox/video-dota-000e704b381e91749ae32f5f846b34ce4238139b9f83c9dd93095a7865598ecc.mp4";